import { Component, Input } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { CurrencyPipe } from '@angular/common';

import { PricingBreakdownComponentInput } from './generic-pricing-breakdown.component.interface';

@Component({
  selector: 'wl-generic-pricing-breakdown[breakdown]',
  templateUrl: './generic-pricing-breakdown.component.html',
  styleUrls: ['./generic-pricing-breakdown.component.scss'],
  standalone: true,
  imports: [FaIconComponent, CurrencyPipe],
})
export class GenericPricingBreakdownComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() breakdown!: PricingBreakdownComponentInput;
}
